import { MultiSelect, SelectOptionType } from "@aidkitorg/component-library";
import { useCallback, useMemo } from "react";
import { useLocalizedStrings } from "../../../../Localization";
import { FilterWrapper } from "../../../components/FilterWrapper";

interface StatusFilterProps {
  selectedStatuses: string[];
  availableStatuses: string[];
  onStatusesChange: (statuses: string[]) => void;
}

export const StatusFilter: React.FC<StatusFilterProps> = ({
  selectedStatuses,
  availableStatuses,
  onStatusesChange,
}) => {
  const L = useLocalizedStrings();

  const statusOptions = useMemo(() => {
    return availableStatuses.map(status => ({
      value: status,
      label: status.charAt(0).toUpperCase() + status.slice(1),
    }));
  }, [availableStatuses]);

  const selectedStatusOptions = useMemo(() => {
    return statusOptions.filter(option => selectedStatuses.includes(option.value));
  }, [statusOptions, selectedStatuses]);

  const handleStatusesChange = useCallback((selectedOptions: SelectOptionType[]) => {
    const newStatuses = selectedOptions.map(option => option.value);
    onStatusesChange(newStatuses);
  }, [onStatusesChange]);

  return (
    <FilterWrapper label={L.admin_panel.notifications.status}>
      <div className="pt-1.5">
        <MultiSelect
          hideLabel
          label={L.admin_panel.notifications.status}
          description={L.admin_panel.notifications.filter_by_status}
          options={statusOptions}
          value={selectedStatusOptions}
          onChange={handleStatusesChange}
          placeholder={L.admin_panel.notifications.select_status}
          searchable={true}
        />
      </div>
    </FilterWrapper>
  );
};
